import {closeWidget, openWidget, setProposalConfirmed} from '../../state/slice/aiAssistant';
import {dispatch} from '../../state/store';
import log from '../logger/log';
import aiAssistantAudioLevelService from './aiAssistantAudioLevelService';

/**
 * Everything the backend must hear from the widget. The voice WebSocket (see docs/AI-ASSISTANT.md) will plug
 * in here; until then the calls only update Redux.
 */

// TODO: open the socket, send `session.start`, start mic capture and pass it to aiAssistantAudioLevelService.start()
const startSession = () => {
    log.info('aiAssistantSessionService: session started');

    dispatch(openWidget());
};

// TODO: close the socket (a clean close ends the session, there is no `session.end`)
const endSession = () => {
    log.info('aiAssistantSessionService: session ended');

    // Stop metering so the aura doesn't stay lit
    aiAssistantAudioLevelService.stop();

    dispatch(closeWidget());
};

// TODO: send `action.confirm`. The Voice Gateway writes the setting and replies with `action.result` - never the client
const confirmProposal = (settingName) => {
    log.info(`aiAssistantSessionService: proposal confirmed for '${settingName}'`);

    dispatch(setProposalConfirmed(settingName));
};

export default {startSession, endSession, confirmProposal};
